"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var styleOverrides = {
    standard: {
        '&:focus': {
            backgroundColor: 'unset'
        }
    },
    outlined: {
        borderRadius: 5
    }
};
var defaultProps = {
    IconComponent: _icons.ArrowDownThin,
    MenuProps: {
        elevation: 0,
        classes: {
            paper: 'OriSelectPaper',
            list: 'OriSelectList'
        },
        BackdropProps: {
            invisible: true
        }
    }
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiSelect.js.map
